import { render, staticRenderFns } from "./ApiHistories.vue?vue&type=template&id=49bb7ab0&scoped=true"
import script from "./ApiHistories.vue?vue&type=script&lang=js"
export * from "./ApiHistories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bb7ab0",
  null
  
)

export default component.exports